import { AbstractIcon } from "./abstract";
import { componentsRegistryService } from "cruzo";

/** IBM Carbon Design System — notebook-reference icon (32px artboard). */
export class CarbonNotebookReferenceIcon extends AbstractIcon {
  static selector = "carbon-notebook-reference-icon";

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
      <polygon points="4 20 4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20"/>
      <rect x="19" y="10" width="7" height="2"/>
      <rect x="19" y="15" width="7" height="2"/>
      <rect x="19" y="20" width="7" height="2"/>
      <path d="M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"/>
    </svg>`;
  }
}

componentsRegistryService.define(CarbonNotebookReferenceIcon);
